import { isPlatformUser } from '@/stores/auth'
import { useAuthStore } from '@/stores/authStore'
import { toast } from 'sonner'
import { DEFAULT_FOOTER_BAR_PREFS, type FooterBarPrefs } from './footerBarModel'

export const useFooterBarPrefs = (): FooterBarPrefs =>
	useAuthStore(s => (isPlatformUser(s.user) ? s.user.settings?.sidebarBar : undefined) ?? DEFAULT_FOOTER_BAR_PREFS)

const applyLocally = (prefs: FooterBarPrefs | undefined) =>
	useAuthStore.setState(state =>
		isPlatformUser(state.user)
			? { user: { ...state.user, settings: { ...state.user.settings, sidebarBar: prefs } } }
			: {},
	)

let newest: FooterBarPrefs | undefined

/** Applied at once so a drag never snaps back while the request is in flight; rolled back if it fails. */
export function saveFooterBarPrefs(prefs: FooterBarPrefs | undefined): void {
	const { user, updateUserSettingsWith } = useAuthStore.getState()
	if (!isPlatformUser(user)) {
		return
	}
	const previous = user.settings?.sidebarBar
	newest = prefs
	applyLocally(prefs)
	updateUserSettingsWith(current => ({ ...current, sidebarBar: prefs }))
		// A finished write stores the settings it sent, which can predate a quicker second edit.
		.then(() => applyLocally(newest))
		.catch(() => {
			if (newest === prefs) {
				newest = previous
				applyLocally(previous)
			}
			toast.error('Could not save the bar')
		})
}
